/**
 * Exhaustive list of player events.
 *
 * See below the documentation related to the media events
 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events
 *
 * @namespace {Object} PlayerEvents
 */
export const ABORT = 'abort';
export const CAN_PLAY = 'canplay';
export const CAN_PLAY_THROUGH = 'canplaythrough';
export const DURATION_CHANGE = 'durationchange';
export const EMPTIED = 'emptied';
export const ENDED = 'ended';
export const ERROR = 'error';
export const LOADED_DATA = 'loadeddata';
export const LOADED_METADATA = 'loadedmetadata';
export const LOAD_START = 'loadstart';
export const PAUSE = 'pause';
export const PLAY = 'play';
export const PLAYING = 'playing';
export const PROGRESS = 'progress';
export const RATE_CHANGE = 'ratechange';
export const RESIZE = 'resize';
export const SEEKED = 'seeked';
export const SEEKING = 'seeking';
export const STALLED = 'stalled';
export const SUSPEND = 'suspend';
export const TIME_UPDATE = 'timeupdate';
export const TRANSITION_END = 'transitionend';
export const VOLUME_CHANGE = 'volumechange';
export const WAITING = 'waiting';
